import { PawPrint, BadgeCheck, Sparkles } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const newShelters = [
  { name: "Schronisko dla Bezdomnych Zwierząt", city: "Katowice" },
  { name: 'Schronisko "Arka" ŁTOZ', city: "Łomża" },
  { name: "Ochota na Kota", city: "Warszawa" },
  { name: "Stowarzyszenie Cztery Łapy", city: "Olecko" },
];

const accentColor = "#4E8A6E";

export const InstagramStory4Verified2 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f5f9f7",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Decorative circles */}
      <div
        style={{
          position: "absolute",
          top: "180px",
          right: "-60px",
          width: "250px",
          height: "250px",
          borderRadius: "50%",
          background: "rgba(78,138,110,0.08)",
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "200px",
          left: "-80px",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "rgba(78,138,110,0.06)",
          zIndex: 1,
        }}
      />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 60px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "56px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "14px", marginBottom: "20px" }}>
            <Sparkles style={{ width: "42px", height: "42px", color: "#F4C430" }} />
            <span style={{ fontSize: "44px", fontWeight: 700, color: "#4E8A6E" }}>
              Nowe na mapie!
            </span>
            <Sparkles style={{ width: "42px", height: "42px", color: "#F4C430" }} />
          </div>
          <h1 style={{ fontSize: "76px", fontWeight: 800, color: "#2D5A3D", margin: 0, lineHeight: 1.1 }}>
            4 schroniska
          </h1>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", margin: "8px 0 0" }}>
            <span style={{ fontSize: "50px", fontWeight: 700, color: "#4A7A5E" }}>
              zweryfikowały profil
            </span>
            <BadgeCheck style={{ width: "46px", height: "46px", color: "#4E8A6E" }} />
          </div>
        </div>

        {/* Numbered cards */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            justifyContent: "center",
          }}
        >
          {newShelters.map((shelter, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.97)",
                borderRadius: "20px",
                padding: "32px 36px",
                display: "flex",
                alignItems: "center",
                gap: "22px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                borderLeft: `6px solid ${accentColor}`,
              }}
            >
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  background: accentColor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  fontSize: "28px",
                  fontWeight: 800,
                  color: "#FFFFFF",
                }}
              >
                {i + 1}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
                <span style={{ fontSize: "32px", fontWeight: 700, color: "#2D5A3D", lineHeight: 1.2 }}>
                  {shelter.name}
                </span>
                <span style={{ fontSize: "26px", fontWeight: 500, color: "#6B8A7A" }}>
                  📍 {shelter.city}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div style={{ textAlign: "center", marginTop: "48px" }}>
          <p style={{ fontSize: "38px", fontWeight: 700, color: "#4A7A5E", marginBottom: "24px" }}>
            Sprawdź ich potrzeby! 🐾
          </p>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
